import React from 'react';
import '../template-file-css/document-file-template.css';


export const RRTS_monthlyStaffForm = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='RRTS_monthlyStaffForm' className='file-pdf-document'>
            <div className='file-template'>
                {/* <table>
        <tr>
            <td colspan="2">
                <span className='eleHeader'>Region:</span>
                <textarea id="txtRegion" name="txtRegion" className='add-only'></textarea>
            </td>
        </tr>
        <tr>
            <td colspan="2">
                <span className='eleHeader'>Region:</span>
                <input type='text' id="txtRegion" name="txtRegion" className='add-only'>
            </td>
        </tr>
        <tr>
            <td className='w-375'>
                <span className='eleHeader'>System ID:</span>
                <textarea id="txtSystemID" name="txtSystemID" CssclassName='add-only' />
            </td>
            <td className='w-375'>
                <span className='eleHeader'>Division:</span>
                <input type='text' id="txtDivision" name="txtDivision" className='add-only' />

            </td>
        </tr>
        <tr>
            <td className='w-375'>
                <span className='eleHeader'>Primary Ethnicity:</span>
                <input type='text' id="txtEthnicity" name="txtEthnicity" className='add-only' />
            </td>
            <td className='w-375'>
                <span className='eleHeader'>Next Due Date:</span>
                <input type='date' id="txtNextDueDate" name="txtNextDueDate" className='add-only' />
            </td>
        </tr>
        <tr>
            <td className='w-375'>
                <span className='eleHeader'>Follow-up Record Completed:</span>
                <select id="ddlFollowUpCompleted" name="ddlFollowUpCompleted" className='add-only'>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                </select>
            </td>
            <td className='w-375'>&nbsp;</td>
        </tr>
    </table> */}





                <h3>Attendance</h3>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>System ID:</span>
                            <input type='text' id="txtSystemID" name="txtSystemID" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Division:</span>
                            <input type='text' id="txtDivision" name="txtDivision" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Primary Ethnicity:</span>
                            <input type='text' id="txtEthnicity" name="txtEthnicity" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Next Due Date:</span>
                            <input type='date' id="txtNextDueDate" name="txtNextDueDate" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Follow-up Record Completed:</span>
                            <select id="ddlFollowUpCompleted" name="ddlFollowUpCompleted" className='add-only' >
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>
                        </td>
                        <td className='w-375'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <h3>
                    Attendance</h3>
                <p>
                    <span className='eleHeader'>Agency Staff in Attendance</span>
                    <textarea id="txtAgencyStaff" name="txtAgencyStaff" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Collaborative Staff in Attendance</span>
                    <textarea id="txtCollborativeStaff" name="txtCollborativeStaff" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Family in Attendance</span>
                    <textarea id="txtFamily" name="txtFamily" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Individuals invited but not in attendance, explain:</span>
                    <textarea id="txtDidNotAttend" name="txtDidNotAttend" className='add-only'></textarea>
                </p>
                <h3>
                    Case Overview</h3>
                <p>
                    <span className='eleHeader'>Progress</span>
                    <select id="ddlProgress" name="ddlProgress" className='add-only'>
                        <option value="Significant Progress">Significant Progress</option>
                        <option value="Some Progress">Some Progress</option>
                        <option value="No Progress">No Progress</option>
                        <option value="Some Regression">Some Regression</option>
                        <option value="Significant Regression">Significant Regression</option>
                        <option value="Not Applicable">Not Applicable</option>
                    </select>
                </p>
                <p>
                    <span className='eleHeader'>Case Overview</span>
                    <textarea id="txtCaseOverview" name="txtCaseOverview" className='add-only'></textarea></p>
                <h3>
                    Court/DFCS Involvement</h3>
                <p>
                    <span className='eleHeader'>Is there court involvement?</span>
                    <select id="ddlCourtInvolvement" name="ddlCourtInvolvement" className='add-only'>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                    </select>
                </p>

                <p>
                    <span className='eleHeader'>If yes, what for?</span>
                    <textarea id="txtYesCourtInvolvement" name="txtYesCourtInvolvement" className='add-only'></textarea></p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Next scheduled court date:</span>
                            <input type='date' id="txtNextCourtDate" name="txtNextCourtDate" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Current Probation Office/DFCS Caseworker:</span>
                            <input type='text' id="txtCurrentPO" name="txtCurrentPO" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h3>
                    Agency Checklist</h3>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Clinical Assessment:</span>
                            <select id="ddlClinicalAssessment" name="ddlClinicalAssessment" className='add-only' >
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>

                            <span className='eleHeader'>Date Completed:</span>
                            <input type='date' id="txtClinicalAssessmentDate" name="txtClinicalAssessmentDate" className='add-only' />

                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>ISP:</span>
                            <select id="ddlISP" name="ddlISP" className='add-only'>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>

                            <span className='eleHeader'>Date Completed:</span>
                            <input type='date' id="txtISPDate" name="txtISPDate" className='add-only' />

                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Nursing Assessment:</span>
                            <select id="ddlNursingAssessment" name="ddlNursingAssessment" className='add-only'>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>

                            <span className='eleHeader'>Date Completed:</span>
                            <input type='date' id="txtNursingAssessmentDate" name="txtNursingAssessmentDate" className='add-only' />

                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Psychological:</span>
                            <select id="ddlPsychological" name="ddlPsychological" className='add-only'>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>

                            <span className='eleHeader'>Date Completed:</span>
                            <input type='date' id="txtPsychologicalDate" name="txtPsychologicalDate" className='add-only' />

                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Safety Plan:</span>
                            <select id="ddlSafetyPlan" name="ddlSafetyPlan" className='add-only'>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>

                            <span className='eleHeader'>Date Completed:</span>
                            <input type='date' id="txtSafetyPlanDate" name="txtSafetyPlanDate" className='add-only' />
                            <span className='small'>(Update every 30 days)</span>

                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>PO Logs:</span>
                            <select id="ddlPOLogs" name="ddlPOLogs" className='add-only'>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>

                            <span className='eleHeader'>Date Completed:</span>
                            <input type='date' id="txtPOLogsDate" name="txtPOLogsDate" className='add-only' />
                            <span className='small'>(Completed weekly)</span>

                        </td>
                    </tr>
                </table>
                <h3>
                    ISP Review</h3>
                <p>
                    <textarea id="txtISPReview" name="txtISPReview" className='add-only'></textarea></p>
                <h3>
                    SNAPS</h3>
                <p>
                    <span className='eleHeader'>Consumer's Strengths</span>
                    <textarea id="txtStrengths" name="txtStengths" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Consumer's Needs</span>
                    <textarea id="txtNeeds" name="txtNeeds" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Consumer's Abilities</span>
                    <textarea id="txtAbilities" name="txtAbilities" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Consumer's Preferences</span>
                    <textarea id="txtPreferences" name="txtPreferences" className='add-only'></textarea>
                </p>
                <h3>
                    Review of Services Being Provided</h3>
                <p>
                    <span className='eleHeader'>Additional Services Needed</span>
                    <textarea id="txtAdditionalNeeds" name="txtAdditionalNeeds" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Has the therapist made the required visits?</span>
                    <select id="ddlTherapistReqVisits" name="ddlTherapistReqVisits" className='add-only'>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                    </select>
                </p>

                <p>
                    <span className='eleHeader'>List the dates of service within last 30 days</span>
                    <textarea id="txtTherapistServiceDates" name="txtTherapistServiceDates" className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>If a therapist is not assigned to the case, does a therapist
                                need to be assigned?</span>
                            <select id="ddlTherapistNeeded" name="ddlTherapistNeeded" className='add-only'>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Has the paraprofessional made the required visits?</span>
                            <select id="ddlParaProReqVisits" name="ddlParaProReqVisits" className='add-only'>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>
                        </td>
                    </tr>
                </table>

                <p>
                    <span className='eleHeader'>List the dates of service within last 30 days</span>
                    <textarea id="txtParaProServiceDates" name="txtParaProServiceDates" className='add-only'></textarea>
                </p>

                <p>
                    <span className='eleHeader'>List the missed appointments in the last 30 days</span>
                    <textarea id="txtMissedAppointments" name="txtMissedAppointments" className='add-only'></textarea>
                </p>
                <h3>
                    Reassessments Needed</h3>
                <p>
                    <span className='eleHeader'>Please note any reassessments that are needed</span>
                    <textarea id="txtNeededReassessments" name="txtNeededReassessments" className='add-only'></textarea>
                </p>
                <h3>
                    Community Linkage</h3>
                <p>
                    <span className='eleHeader'>Please note any community linkages/resources provided
                        within the last 30 days</span>
                    <textarea id="txtCommunityLinkage" name="txtCommunityLinkage" className='add-only'></textarea>
                </p>
                <h3>
                    Additional Comments</h3>
                <p>
                    <span className='eleHeader'>Please note any additional comments</span>
                    <textarea id="txtAdditionalComments" name="txtAdditionalComments" className='add-only'></textarea>
                </p>

            </div>
        </form>

    )
}   